<template>
  <div class="sections row q-col-gutter-x-sm q-col-gutter-y-sm q-col-gutter-lg-lg">
    <div
        v-for="item of sections"
        :key="item.ID"
        class="c-item col-8 col-sm-8 col-md-6 col-lg-4 "
    >
      <div
          class="c-item__inner bg-white q-py-md text-center full-height cursor-pointer relative-position"
          @click="onClick(item)"
          v-ripple
      >
        <UiImg
            v-if="item.PICTURE?.SRC"
            :src="imageResolve(item.PICTURE?.SRC, 'm-1-4')"
            :ratio="16/9"
            fit="contain"
            fetchpriority="high"
        />
        <div class="c-item__label text-weight-bolder s-font-xs s-font-md-md q-mt-md q-px-sm">{{ item.NAME }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

import UiImg from "@/components/Ui/Image/UiImg.vue";
import {useImager} from "@/core/store/imager";
import {executeAfterAnimation} from "@/core/util/executeAfterAnimation";
import {ProductSection} from "@/gql/gen";
import {useCatalogStore} from "@/modules/shop/store/catalog";
import {storeToRefs} from "pinia";
import {computed} from "vue";
import {useRouter} from "vue-router";

const router = useRouter()
const {imageResolve} = useImager()

const catalogStore = useCatalogStore()

const {sectionsTree} = storeToRefs(catalogStore)

const sections = computed(() => sectionsTree.value.filter(section => section.PICTURE))

const onClick = (item: ProductSection) => {
  executeAfterAnimation(() => {
    router.push({path: '/', hash: '#' + item.CODE})
  }, {priority: 'user-visible'})
}

</script>

<style lang="scss" scoped>

.c-item__inner {
  border-radius: 20px;
  box-shadow: 0 5px 15px -5px rgba(34, 60, 80, 0.2);
  border: 1px solid #eee;
}

.c-item__label {
  line-height: 1.1;
}

</style>
